import { useEffect, useRef } from 'react';

export default function EventOverview() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const sampleImages = [
    {
      url: 'https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/e999c6e4cf18ff066a7569b21295e489.jpeg',
      alt: '스튜디오 상 샘플 이미지 1'
    },
    {
      url: 'https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/fef800650ec584eaec0cbbc9b2cafdca.jpeg',
      alt: '스튜디오 상 샘플 이미지 2'
    },
    {
      url: 'https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/624f60ebb2ebf96a7fe40f64466b3454.jpeg',
      alt: '스튜디오 상 샘플 이미지 3'
    },
    {
      url: 'https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/549696b294529ba5e671f06d9dcaed66.jpeg',
      alt: '스튜디오 상 샘플 이미지 4'
    },
    {
      url: 'https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/8df6781422a5b7b99f5345a920f2a3e7.jpeg',
      alt: '스튜디오 상 샘플 이미지 5'
    }
  ];

  // 이미지 배열을 3번 복제하여 무한 스크롤 효과
  const allImages = [...sampleImages, ...sampleImages, ...sampleImages];

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    let scrollPosition = 0;
    const scrollSpeed = 0.5; // 스크롤 속도 (픽셀/프레임)
    const imageWidth = 260; // 이미지 너비 + 간격
    const totalWidth = imageWidth * sampleImages.length;

    const animate = () => {
      scrollPosition += scrollSpeed;
      
      // 한 세트의 이미지를 지나면 위치 리셋
      if (scrollPosition >= totalWidth) {
        scrollPosition = 0;
      }
      
      container.style.transform = `translateX(-${scrollPosition}px)`;
      requestAnimationFrame(animate);
    };

    const animationId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationId);
  }, [sampleImages.length]);

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block w-16 h-px bg-neutral-300 mb-8"></div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl mb-8 font-light tracking-tight text-neutral-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            A Year of Gratitude
          </h2>
          <p className="text-base md:text-lg text-neutral-600 leading-relaxed max-w-2xl mx-auto font-light">
            감사의 마음을 담아 특별한 경품 이벤트를 진행합니다
          </p>
        </div>

        {/* 자동 슬라이드 이미지 갤러리 - 3:4 비율 (세로형) */}
        <div className="mt-16 mb-12 overflow-hidden">
          <div 
            ref={scrollContainerRef}
            className="flex gap-4"
            style={{ width: 'fit-content' }}
          >
            {allImages.map((image, index) => (
              <div 
                key={index}
                className="flex-shrink-0 w-60 bg-neutral-100 overflow-hidden"
                style={{ height: '320px' }}
              >
                <img 
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            ))}
          </div>
        </div>

        {/* 감사 메시지 */}
        <div className="text-center mt-12">
          <p className="text-base md:text-lg text-neutral-600 leading-relaxed font-light">
            2025년 스튜디오 상과 함께해주신 모든 분들께 진심으로 감사드립니다
          </p>
        </div>
      </div>
    </section>
  );
}
